import { get } from '~shared/utils/http';

import { initialiseCommonStore } from '~shared/components/react/CommonDataStore/actions';
import { COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS } from '~shared/components/react/CommonDataStore/actionTypes';
import mainSocket from '~shared/services/mainSocketClass';
import { buildSpectateUrl } from '~spa/Utils/Spectate';
import {
    POPULAR_WIDGET_ERROR,
    POPULAR_WIDGET_LOADING_SUCCESS,
    POPULAR_WIDGET_START_LISTENING_FOR_WS_UPDATES,
    POPULAR_WIDGET_STOP_LISTENING_FOR_WS_UPDATES,
} from './popularWidgetActionTypes';

export const popularWidgetErrorOccurred = bool => {
    return {
        type: POPULAR_WIDGET_ERROR,
        errorOccurred: bool,
    };
};
export const POPULAR_URL = buildSpectateUrl('/sportsbook-req/getPopularWidgetEventsAjax');
export const getPopularWidgetEvents = (wsEventListener) => {

    return async (dispatch) => {
        try {

            const response = await get(POPULAR_URL);

            if (!response.ok) {
                dispatch(popularWidgetErrorOccurred(true));

                return;
            }

            const data = await response.json();

            dispatch([
                initialiseCommonStore(data.events),
                startListeningForWsUpdates(data.selection_pointers),
                popularWidgetEvents(data.event_order),
            ]);

            mainSocket.onWsEventUpdate(wsEventListener);
        } catch (e) {

            dispatch(popularWidgetErrorOccurred(true));
        }
    };
};

export const popularWidgetEvents = (events) => {
    return {
        type: POPULAR_WIDGET_LOADING_SUCCESS,
        events,
    };
};

export const startListeningForWsUpdates = (events) => {
    return {
        type: POPULAR_WIDGET_START_LISTENING_FOR_WS_UPDATES,
        events,
    };
};

export const stopListeningForUpdates = () => {
    return {
        type: POPULAR_WIDGET_STOP_LISTENING_FOR_WS_UPDATES,
    };
};

export const updateCommonStoreWsData = wsData => {
    return {
        type: COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS,
        wsData: wsData,
    };
};
